import { render, staticRenderFns } from "./NuevaVentaGmoPeru.vue?vue&type=template&id=6cb03aa4&"
import script from "./NuevaVentaGmoPeru.vue?vue&type=script&lang=js&"
export * from "./NuevaVentaGmoPeru.vue?vue&type=script&lang=js&"
import style0 from "./NuevaVentaGmoPeru.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports